import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';
import { Helmet } from 'react-helmet-async';
import taxi from './belfast-cab-tour-faqs.png';
import moneyIcon from '../assets/images/belfast-taxi-tours-prices.svg';
import timeIcon from '../assets/images/belfast-taxi-tour-time.svg';
import startEndIcon from '../assets/images/belfast-taxi-tour-start-end.svg';
import bookingIcon from '../assets/images/belfast-taxi-tour-booking.svg';
import paymentIcon from '../assets/images/belfast-cab-tour-payment-method.svg';
import groupIcon from '../assets/images/belfast-taxi-tour-group.svg';
import wheelchairIcon from '../assets/images/belfast-taxi-tour-wheelchair.svg';
import balancedIcon from '../assets/images/belfast-cab-tour-balanced-view.svg';
import landmarksIcon from '../assets/images/belfast-taxi-tour-landmarks.svg';
import dropOffIcon from '../assets/images/belfast-taxi-tour-drop-off.svg';
import '../Styles.css';

const Blog = () => {
  const [scrollTop, setScrollTop] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollTop(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        margin: 0,
        padding: 0,
      }}
    >

        {/* ✅ Helmet for page title & meta tags */}
        <Helmet>
        <title>Belfast Taxi Tours FAQs | Prices, Duration, Accessibility & More</title>
        <meta
          name="description"
          content="Find answers to frequently asked questions about Belfast Taxi Tours — including pricing, duration, accessibility, booking, payment options, and more. Plan your Belfast cab tour today."
        />
        </Helmet>

      <Navbar />

      {/* Header Section - Added margin-top to account for fixed navbar */}
      <header className="Packages-header" style={{ marginTop: '60px' }}>
        <div className="animation-wrapper">
          <img
            src={taxi}
            className="taxi"
            alt="taxi"
            style={{
              top: '-2%',
              transform: `translateY(-${scrollTop / 100}%)`,
            }}
          />
        </div>
      </header>

      <main style={{ padding: '0 1rem', maxWidth: 900, margin: '0 auto' }}>

        <article style={{ marginBottom: '0rem' }}>
          <h1 className="Blogs-header" style={{ textAlign: 'center' }}>
            <img 
            src={moneyIcon} 
            alt="taxi tour price icon" 
            style={{ width: '40px', height: '40px', marginBottom: '12px' }} 
            />
            What is the price of a Belfast black cab tour?
          </h1>
          <section className="Blogs-content" style={{ textAlign: 'left' }}>
            <p>
            A Belfast black cab tour costs £70 for up to two people. Each additional passenger is charged £35, and prices are fixed regardless of the day or time.
            </p>
            <p>
            Our Belfast black cab tours are priced clearly and simply to make planning easy. The standard rate is £70, which covers up to two passengers. If you're travelling with a larger group, each extra person is charged at £35. This pricing structure is consistent and transparent, with no hidden fees or weekend surcharges. The tour itself lasts approximately 90 minutes and includes visits to some of the most iconic and historically significant sites across Belfast, including the Peace Walls, political murals, and key neighbourhoods from both sides of the city's divide. Your guide is a knowledgeable local driver with first-hand insight into Belfast's complex past, offering personal stories, historical context, and opportunities to ask questions throughout the journey. All tours are conducted in traditional black taxis, providing a comfortable and authentic experience. Booking in advance is recommended to secure your preferred time slot, especially during peak seasons. Whether you're visiting solo, as a couple, or in a small group, our pricing remains straightforward so you can focus on enjoying the experience, not calculating the cost.
            </p>
          </section>
        </article>

        <article style={{ marginBottom: '0rem' }}>
          <h1 className="Blogs-header" style={{ textAlign: 'center' }}>
            <img 
            src={timeIcon} 
            alt="taxi tour time icon"
            style={{ width: '40px', height: '40px', marginBottom: '10px' }} 
            />
            How much time should I set aside for a black cab tour in Belfast?
          </h1>
          <section className="Blogs-content" style={{ textAlign: 'left' }}>
            <p>
            Our standard black cab tours last between 1 hour and 1½ hours. Extended tours are also available, running up to 3 or 4 hours depending on your chosen itinerary.
            </p>
            <p>
            A typical Belfast black cab tour takes between 60 to 90 minutes, making it a perfect fit for visitors who want a rich, immersive experience without taking up the whole day. During this time, you'll visit key historical and political sites across the city, including the famous murals, Peace Walls, and neighbourhoods that shaped Belfast's story. If you're looking for something more in-depth, we also offer extended tours lasting up to 3 or even 4 hours. These longer versions allow for additional stops, more detailed discussions, and the flexibility to tailor the route based on your interests—whether that's delving deeper into the Troubles, exploring lesser-known parts of the city, or combining political history with cultural highlights. No matter which tour length you choose, you'll be accompanied by an experienced local guide who offers thoughtful commentary and personal insights throughout the journey. The time you spend on tour is entirely your own—no rushing, no crowds, and plenty of opportunity to ask questions or pause for photos. Whether you're here for a day or a week, our tour durations are designed to fit neatly into your travel plans while delivering a memorable and informative experience.
            </p>
          </section>
        </article>

        <article style={{ marginBottom: '0rem' }}>
        <h1 className="Blogs-header" style={{ textAlign: 'center' }}>
        <div style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center' }}>
        <img 
        src={startEndIcon} 
        alt="taxi tour start end icon"
        style={{ width: '32px', height: '32px', marginBottom: '8px' }} 
        />
        Where do the tours start and end?
  </div>
</h1>
          <section className="Blogs-content" style={{ textAlign: 'left' }}>
            <p>
            Most tours begin and end at Belfast City Hall or another central location. Hotel and cruise terminal pickups are also available, with some locations incurring an additional fee.
            </p>
            
            <p>
            Our Belfast black cab tours typically start and finish in the heart of the city, with Belfast City Hall being the most common meeting point due to its central and easily accessible location. However, we understand that convenience matters, so we also offer pickup and drop-off services from most city centre hotels and cruise terminals. If you're arriving by ship or staying outside the city centre, we can usually arrange a custom pickup—though in some cases, this may involve a small additional fee to cover travel time. Whether you're based downtown or docking for a day trip, we aim to make the experience as seamless as possible. The tour ends where it began unless you prefer to be dropped off somewhere else in central Belfast, such as a museum, restaurant, or your accommodation. Just let us know in advance and we'll do our best to accommodate. Our goal is to make your tour stress-free from start to finish, so you can focus on enjoying the stories, sites, and scenery without worrying about logistics. Simply confirm your preferred pickup location when booking, and we'll handle the rest.
            </p>
          </section>
        </article>

        <article style={{ marginBottom: '0rem' }}>
          <h1 className="Blogs-header" style={{ textAlign: 'center' }}>
            <img 
            src={bookingIcon} 
            alt="taxi tour booking icon"
            style={{ width: '35px', height: '35px', marginBottom: '12px' }} 
            />
            Do I need to pre‑book?
          </h1>
          <section className="Blogs-content" style={{ textAlign: 'left' }}>
            <p>
            Yes, advance booking is highly recommended. Most tours require at least 24 hours' notice, and slots during the busy summer months can fill up quickly.
            </p>
            <p>
            To ensure availability and a smooth experience, we strongly advise booking your Belfast black cab tour in advance. Most operators require a minimum of 24 hours' notice to schedule a guide and prepare the vehicle, and some may not be able to accommodate same-day requests—especially during peak travel seasons. The summer months, in particular, tend to book out quickly due to high demand from both international visitors and cruise ship passengers. Booking early not only secures your preferred time slot but also allows for any special requests or custom pickup arrangements to be organized ahead of time. Whether you're travelling solo, as a couple, or with a larger group, confirming your booking in advance helps us tailor the experience to your needs and guarantees you won't miss out. You can usually reserve online, by phone, or through email, depending on the company. Once confirmed, you'll receive all the essential details, including your driver's name, meeting point, and any helpful tips for the day. In short, pre-booking is the best way to avoid disappointment and make the most of your time in Belfast.
            </p>
          </section>
        </article>

        <article style={{ marginBottom: '0rem' }}>
          <h1 className="Blogs-header" style={{ textAlign: 'center' }}>
            <img 
            src={paymentIcon} 
            alt="taxi tour payment icon"
            style={{ width: '35px', height: '35px', marginBottom: '12px' }} 
            />
            What payment methods are accepted for black cab tours?
          </h1>
          <section className="Blogs-content" style={{ textAlign: 'left' }}>
            <p>
            Most black cab tours are paid in cash, using pounds sterling. While some drivers may accept card payments, it's best to carry cash just in case.
            </p>
            <p>
            Payment for Belfast black cab tours is typically made directly to the driver at the end of your tour. The preferred method is cash in pounds sterling, which remains the most reliable and straightforward option. While a few drivers do accept card payments, this is not always guaranteed—especially if the driver's mobile terminal is unavailable. Because of this, visitors are strongly encouraged to bring enough cash to cover the full cost of the tour. If you're arriving from outside the UK, it's a good idea to exchange currency beforehand or withdraw pounds from an ATM in the city centre. Tipping your driver is appreciated but optional, and if you choose to do so, cash is again preferred. Overall, bringing cash ensures there are no hiccups at the end of your tour and allows everything to run smoothly, so you can focus on enjoying the experience rather than worrying about payment logistics.
            </p>
          </section>
        </article>

        <article style={{ marginBottom: '0rem' }}>
          <h1 className="Blogs-header" style={{ textAlign: 'center' }}>
            <img 
            src={groupIcon} 
            alt="taxi tour group icon"
            style={{ width: '35px', height: '35px', marginBottom: '12px' }} 
            />
            How many passengers can a black cab accommodate?
          </h1>
          <section className="Blogs-content" style={{ textAlign: 'left' }}>
            <p>
            Most black taxi cabs can comfortably seat between 4 and 6 passengers. However, we also have larger vehicles and offer multiple taxis for bigger groups.
            </p>
            <p>
            Belfast black cabs are well-suited for small groups, with most vehicles accommodating 4 to 6 passengers comfortably. Traditional black taxis are designed with spacious interiors and rear-facing seats, making it easy for everyone to interact and enjoy the guide's commentary during the tour. We also provide slightly larger 6- or 7-seater vehicles, ideal for families or small groups travelling together. If your party includes more than six people, additional taxis can be arranged to run side by side, ensuring the group stays together throughout the tour. It's a good idea to mention your group size when booking so the right vehicle can be prepared in advance. Regardless of group size, the focus remains on providing a personalised and engaging tour experience, with plenty of opportunities for questions, photos, and interaction. Whether you're a couple, a family, or a tour group, there's a vehicle setup to suit your needs and make your time in Belfast both comfortable and memorable.
            </p>
          </section>
        </article>

        <article style={{ marginBottom: '0rem' }}>
          <h1 className="Blogs-header" style={{ textAlign: 'center' }}>
            <img 
            src={wheelchairIcon} 
            alt="taxi tour wheelchair icon"
            style={{ width: '50px', height: '50px', marginBottom: '8px' }} 
            />
            Are Belfast black cab tours accessible for wheelchair users?
          </h1>
          <section className="Blogs-content" style={{ textAlign: 'left' }}>
            <p>
            Yes, many black cabs are wheelchair accessible. Just let us know in advance so the appropriate vehicle can be arranged for your tour.
            </p>
            <p>
            Accessibility is a priority for us, and several vehicles are specially adapted to accommodate wheelchair users. These accessible cabs feature ramps or lifts, allowing for easy entry and exit without the need to transfer out of the chair. To make sure everything goes smoothly, it's important to inform us at the time of booking if a wheelchair-accessible vehicle is needed. This gives our team enough time to allocate the right taxi and make any additional preparations. While not every cab in the fleet may be adapted, there is usually at least one suitable vehicle available—especially if given a little notice. The rest of the tour experience remains the same: engaging storytelling, photo stops, and a personalised look at Belfast's history and culture, all from the comfort of a traditional black cab. Guides are familiar with accommodating mobility needs and are happy to assist where needed, ensuring all passengers feel welcomed and comfortable. If you're visiting Belfast and have accessibility concerns, you can rest assured that with a bit of planning, a black cab tour remains a great and inclusive way to explore the city.
            </p>
          </section>
        </article>

        <article style={{ marginBottom: '0rem' }}>
          <h1 className="Blogs-header" style={{ textAlign: 'center' }}>
            <img 
            src={balancedIcon} 
            alt="taxi tour balanced icon"
            style={{ width: '35px', height: '35px', marginBottom: '14px' }} 
            />
            Do the black cab tours offer a fair and balanced view of Belfast's history?
          </h1>
          <section className="Blogs-content" style={{ textAlign: 'left' }}>
            <p>
            Yes, our black cab tours are designed to be balanced and non-partisan. Our team is made up of Catholic and Protestant guides who aim to present multiple perspectives.
            </p>
            <p>
            One of the defining features of Belfast Cab Tour is our commitment to offering a fair, respectful, and balanced account of the city's complex past. We take great care to present the political and historical narrative from both sides—Nationalist/Republican and Unionist/Loyalist—without promoting any particular agenda. In fact, we are run with both Catholic and Protestant drivers, each sharing their lived experiences and insights in a way that fosters understanding rather than division. The goal is not to sway opinions, but to inform visitors about the roots and realities of the Troubles, the peace process, and ongoing challenges within the city. Guides are trained to avoid partisan commentary and to answer sensitive questions with honesty and respect. You'll hear personal stories alongside historical context, giving you a fuller picture of how the conflict affected everyday life in different communities. For many visitors, this balanced storytelling is one of the most powerful and thought-provoking parts of the tour. Whether you're already familiar with Belfast's history or coming in with fresh eyes, these tours are carefully designed to educate, challenge, and encourage reflection in a neutral and inclusive way.
            </p>
          </section>
        </article>

        <article style={{ marginBottom: '0rem' }}>
          <h1 className="Blogs-header" style={{ textAlign: 'center' }}>
            <img 
            src={landmarksIcon} 
            alt="taxi tour landmarks icon"
            style={{ width: '35px', height: '35px', marginBottom: '16px' }} 
            />
            What sights and landmarks are included in a Belfast black cab tour?
          </h1>
          <section className="Blogs-content" style={{ textAlign: 'left' }}>
            <p>
            The tour covers key sites like the murals on Falls Road and Shankill Road, the Peace Walls, the International Wall, memorial gardens, and Crumlin Road Gaol, all brought to life with stories from the Troubles.
            </p>
            <p>
            A Belfast black cab tour takes you through some of the most historically significant and visually striking areas of the city. You'll visit iconic political murals along both the Falls Road and Shankill Road, each telling powerful stories from the Nationalist and Unionist communities. The Peace Walls—massive dividing structures still standing between neighbourhoods—are another key stop, offering a chance to learn about their origins, ongoing impact, and the messages people from around the world have left behind. You'll also see the famous International Wall, which features evolving artwork focused on global human rights and political issues. Many tours include visits to memorial gardens honouring those who lost their lives during the Troubles, and some routes pass by or include a stop at Crumlin Road Gaol, a former prison tied to the city's conflict-ridden past. What sets the experience apart is the commentary from your guide—often someone with personal connections to the events being discussed. The stories and context they provide transform these landmarks into something much more meaningful than just sightseeing. Whether you're deeply familiar with Belfast's history or learning about it for the first time, the tour offers a vivid, human perspective on the city's past and present.
            </p>
          </section>
        </article>

        <article style={{ marginBottom: '0rem' }}>
          <h1 className="Blogs-header" style={{ textAlign: 'center' }}>
            <img 
            src={dropOffIcon} 
            alt="taxi tour drop off icon"
            style={{ width: '55px', height: '55px', marginLeft: '6px' }} 
            />
            Can I be dropped off at a specific location after the tour?
          </h1>
          <section className="Blogs-content" style={{ textAlign: 'left' }}>
            <p>
            Yes, we offer drop-off at central Belfast locations like hotels or the Titanic Museum. Longer journeys, such as to the airport, may cost extra and should be arranged in advance.
            </p>
            <p>
            At the end of your black cab tour, we are happy to drop you off at a location of your choice within central Belfast. Popular requests include hotels, restaurants, city landmarks like the Titanic Museum, or transport hubs such as the train station. These custom drop-offs within the city centre are generally included in the price of the tour and can make your day more convenient. If you're hoping to be dropped off somewhere farther afield—like Belfast International Airport, George Best City Airport, or a destination outside the city limits—that can often be arranged as well, but it may involve an additional fee. To avoid any confusion or delays, it's important to mention your preferred drop-off location when booking the tour. That way, the driver can plan the route accordingly and give you a clear idea of any extra cost if applicable. Whether you're continuing your sightseeing, heading to a meal, or catching a flight, this added flexibility helps you make the most of your time in Belfast. The goal is always to offer a comfortable, personalised experience from start to finish—including how and where your tour ends.
            </p>
          </section>
        </article>

      </main>

      {/* Footer Section */}
      <footer
        style={{
          textAlign: 'center',
          padding: '1rem',
          backgroundColor: '#333',
          color: '#fff',
          marginTop: 'auto',
        }}
      >
        &copy; 2025{' '}
        <a
          href="https://belfastcabtour.com"
          style={{
            color: '#fff',
            textDecoration: 'none',
          }}
        >
          belfastcabtour.com
        </a>
        . All rights reserved.
      </footer>
    </div>
  );
};

export default Blog;